module.exports = __webpack_public_path__ + "static/media/collection_page_2027_btn.7ed5aa96.png";